export enum AdServer {
	Xandr = 'xandr',
	OptOut = 'optOut',
}
